import * as Yup from "yup";

export const dataModel = {
  culture: "",
  code: "",
  status: "",
  articleUuid: "",
  viveroUuid: "",
  batch: "",
  varietyUuid: "",
  locationUuid: "",
  sectorUuid: ""
};

export const validationDataModel = Yup.object().shape({
  code: Yup.string().optional(""),
  culture: Yup.string().optional(""),
  status: Yup.string().optional(""),
  articleUuid: Yup.string().optional(""),
  viveroUuid: Yup.string().optional(""),
  batch: Yup.string().optional(""),
  varietyUuid: Yup.string().optional(""),
  locationUuid: Yup.string().optional(""),
  sectorUuid: Yup.string().optional(""),
});

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
